import React, { useState } from 'react';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const handleSubmit = async () => {
    if (email.trim() === '') {
      setError('Email is required');
      return;
    }

    setIsSubmitting(true);
    setError('');
    setMessage('');

    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/forgot-password?email=` + email, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: ''
        })
      });

      const responseText = await res.text();
      const result = responseText ? JSON.parse(responseText) : null;

      if (res.ok) {
        setMessage('A reset link has been sent to your email.');
        setShowToast(true);
        setError('');
        setTimeout(() => setShowToast(false), 1000);
      } else {
        setError(result.message || 'Something went wrong');
        setMessage('');
      }
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError(String(err));
      }
      setMessage('');
    }

  };

  return (
    <main className="main-bg">
      <div className="small-container add-yolo-info text-center">
        <div
          className="start-row d-flex full-height align-items-center"
          style={{ flexDirection: 'column', paddingTop: '0px' }}
        >
          <h2 className="futuralt-book mt-4 pt-2 mb-4">Forgot Password?</h2>
          <p>Enter your email and we’ll send you instructions to reset your password.</p>

          <input
            type="email"
            className="field md-filed text-center"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              boxShadow: 'rgb(149 149 149 / 75%) 0px 8px 12px -5px'
            }}
          />

          {message && <p style={{ color: 'green', marginTop: '10px' }}>{message}</p>}
          {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}

          <input
            type="button"
            className="btn-primary mt-4"
            value="Send Reset Link"
            onClick={handleSubmit}
            disabled={isSubmitting}
            style={{
              backgroundColor: isSubmitting ? '#ccc' : '',
              color: isSubmitting ? '#666' : '',
              transition: 'all 0.3s ease'
            }}

          />

          {showToast && (
            <div
              style={{
                position: 'fixed',
                top: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: '#ddffdd',
                color: '#0b8000',
                padding: '12px 20px',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                fontSize: '16px',
                zIndex: 9999,
                animation: 'floatUp 0.3s ease-out',
              }}
            >
              📧 Email has been sent!
            </div>
          )}


        </div>
      </div>
    </main>
  );
};

export default ForgotPasswordPage;
